import axios from 'axios';

const api = axios.create({
  baseURL: 'https://ffg62b8rce.execute-api.us-east-1.amazonaws.com/prod',
  // baseURL: 'http://localhost:3333/api',
});

export default api;
